import { gql } from '@apollo/client'

export const searchUserCodeRedemption = gql`
  query SearchUserCodeRedemption($user: String, $code: String) {
    UserCodeRedemptionFindMany(filter: { user: $user, AND: { code: $code } }) {
      user
      code
    }
  }
`
